export default "__VITE_ASSET__BlXPi$kr__"